import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import ErrorActions from './error';
import OfferActions from './offer';
import SiteActions from './sites';
import CartActions from './cart';
class UserActions {
    static types = actionsFromList([
        'RECEIVED_USER_SUMMARIES',
        'REQUESTING_USER_SUMMARIES',
        'RECEIVED_USER',
        'REQUESTED_SPOOF',
        'REQUESTING_SPOOF',
        'REQUESTING_USER',
        'UPDATED_PREFERENCES',
        'UPDATE_MAP_USERNAME',
        'UPDATING_PREFERENCES',
        'USERNAME_LOOKUP_FINISHED',
        'USERNAME_LOOKUP_RESET',
        'USERNAME_LOOKUP_STARTED',
    ]);

    // sync --------------------------------------------------------------------

    static requestingUser = () => ({
        type: UserActions.types.REQUESTING_USER,
    });

    static receivedUser = (response) => ({
        type: UserActions.types.RECEIVED_USER,
        payload: { response: response.data },
    });

    static updatingPreferences = () => ({
        type: UserActions.types.UPDATING_PREFERENCES,
    });

    static updatedPreferences = (response) => ({
        type: UserActions.types.UPDATED_PREFERENCES,
        payload: { response: response.data },
    });

    static updateMapUsername = (value) => ({
        type: UserActions.types.UPDATE_MAP_USERNAME,
        payload: { value },
    });

    static usernameLookupStarted = () => ({
        type: UserActions.types.USERNAME_LOOKUP_STARTED,
    });

    static usernameLookupFinished = () => ({
        type: UserActions.types.USERNAME_LOOKUP_FINISHED,
    });

    static usernameLookupReset = () => ({
        type: UserActions.types.USERNAME_LOOKUP_RESET,
    });

    static requestingSummaries = () => ({
        type: UserActions.types.REQUESTING_USER_SUMMARIES,
    });

    static receivedSummaries = (summaries) => ({
        type: UserActions.types.RECEIVED_USER_SUMMARIES,
        payload: { summaries },
    });

    static requestingSpoof = (userId) => ({
        type: UserActions.types.REQUESTING_SPOOF,
        payload: { userId },
    });

    static requestedSpoof = () => ({ type: UserActions.types.REQUESTED_SPOOF });

    // async -------------------------------------------------------------------

    static requestUser = () => (dispatch, getState) => {
        dispatch(UserActions.requestingUser());

        getState()
            .api.getMyUser()
            .then((response) => dispatch(UserActions.receivedUser(response)))
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static updatePreferences = (preferences) => (dispatch, getState) => {
        dispatch(UserActions.updatingPreferences());

        getState()
            .api.updateMyPreferences(preferences)
            .then((response) =>
                dispatch(UserActions.updatedPreferences(response))
            )
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static updateFavorites = (offer, site, server) => (dispatch) => {
        dispatch(
            UserActions.updatePreferences({
                [`favorites${offer.mentorId}`]: {
                    site: site.id,
                    server: server.id,
                },
            })
        );
    };

    static updateServerAlias = (server, alias) => (dispatch) => {
        dispatch(
            UserActions.updatePreferences({
                serverAliases: { [server.id]: alias },
            })
        );
    };

    static lookupMapUsername = (username) => (dispatch, getState) => {
        const state = getState();

        dispatch(UserActions.usernameLookupStarted());

        state.api
            .usernameLookup(username)
            .then(() => dispatch(UserActions.usernameLookupFinished()))
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static fetchSummaries = () => (dispatch, getState) => {
        const state = getState();

        dispatch(UserActions.requestingSummaries());

        state.api
            .getUserSummaries()
            .then((response) =>
                dispatch(UserActions.receivedSummaries(response.data.users))
            )
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static spoofUser = (userId) => (dispatch, getState) => {
        const state = getState();

        dispatch(UserActions.requestingSpoof(userId));

        state.api
            .spoofUser(userId)
            .then(() =>
                Promise.all([state.api.getMyUser(), state.api.getMyOffers()])
            )
            .then(([user, offers]) => {
                dispatch(UserActions.receivedUser(user));
                dispatch(OfferActions.receivedOffers(offers));  
                // when spoofed trying to fetch the user sites of the spoofed user for adding host / server.              
                dispatch(SiteActions.fetchSitesForUserAccount());
                dispatch(CartActions.setItems());

            })
            .then(() => dispatch(UserActions.requestedSpoof()))
            .catch(ErrorActions.errorHandler(dispatch));
    };

    static endSpoof = () => UserActions.spoofUser(null);
}

export default UserActions;



// WEBPACK FOOTER //
// ./app/actions/user.js